import styled from "@emotion/styled"
import { eerieBlack } from "../styles/colors"
import { Typography } from "../styles/typography"
import { DESKTOP_MIN_WIDTH } from "../styles/utils"

/**
 * Section Components
 * Title / Description
 */
 export const SectionTitle = styled.h3`
    ${Typography.heading.h4_700}
    color: ${eerieBlack['800']};
    margin-bottom: ${props => props.marginBottom ?? 24}px;
    max-width: ${props => props.maxWidth}px;
    color: ${props => props.color ?? eerieBlack['800']};
    text-align: ${props => props.center ? 'center' : ''};
    @media (min-width: ${DESKTOP_MIN_WIDTH}) {
      ${Typography.heading.h3_700}
    }
`

export const SectionDescription = styled.h5`
 ${Typography.fonts.inter}
 ${Typography.heading.h6_400}
 text-align: ${props => props.center ? 'center' : ''};
 color: ${props => props.color ?? eerieBlack['800']};
 margin-bottom: ${props => props.marginBottom ?? 0}px;
 max-width: ${props => props.maxWidth}px;
 @media (min-width: ${DESKTOP_MIN_WIDTH}) {
   ${Typography.heading.h5_400}
 }
`